export const NoteTypes = {
    Feed: -1,
    Comment: 0,
    PersonalNote: 1,
    Announcement: 2,
    Calendar: 3,
    EntityAction: 4,
    ActionItem: 5,
};
